import styled from '@emotion/styled';
import { Box } from '@mui/material';

export const Container = styled(Box)`
  margin: 0 -32px;
  display: flex;
  padding: 8px 32px;
  justify-content: center;
  align-items: center;
  gap: 4px;
  border-bottom: 1px solid var(--dk-line, #e7e9ec);
  background: var(--dk-bg-subtle, #f9fafb);
`;

export const Divider = styled(Box)`
  margin: auto 8px;
  width: 1px;
  height: 12px;
  background: var(--dk-purple-soft, #f2dff1);
`;

export const Time = styled(Box)`
  display: flex;
  padding: 1px 4px;
  justify-content: center;
  align-items: center;
  border-radius: 4px;
  border: 1px solid var(--dk-purple-line, var(--ai-tool-portal-ai-solid-24, #f2dff1));
  background: var(--dk-bg, var(--Grayscale-White-FFFFFF, #fff));
  color: var(--AI-Tool-Portal-Ai-Solid, #c77ac4);
  text-align: center;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 18px; /* 150% */
  text-transform: uppercase;
`;
